import React from "react";

export default function usePaging({ resetCondition, defaultPage = 1, defaultMaxPage = 1 } = {}) {
  const [npage, setNPage] = React.useState(() => defaultPage);
  const [page, setPage] = React.useState(() => defaultPage);
  const [maxPage, setMaxPage] = React.useState(() => defaultMaxPage);

  const onPage = React.useCallback((nextPage) => {
    setPage(() => nextPage);
    // setNPage(() => nextPage);
  }, []);
  const onNPage = React.useCallback((nextPage) => {
    setNPage(() => nextPage);
  }, []);
  const onMaxPage = React.useCallback((nextMaxPage) => {
    setMaxPage(() => nextMaxPage);
  }, []);

  React.useEffect(() => {
    setPage(() => defaultPage);
    setNPage(() => defaultPage);
    setMaxPage(() => defaultMaxPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, resetCondition);

  return {
    page,
    npage,
    maxPage,
    onPage,
    onNPage,
    onMaxPage,
  };
}